"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSrcs = exports.getDeviceBasedImages = exports.getImagesSrcSet = void 0;
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
var EDeviceType;
(function (EDeviceType) {
    EDeviceType["Mobile"] = "mobile";
    EDeviceType["Desktop"] = "desktop";
})(EDeviceType || (EDeviceType = {}));
const getImagesSrcSet = (images) => {
    return images.length
        ? images
            .map(({ link, id }) => { var _a; return `${link.url} ${((_a = id === null || id === void 0 ? void 0 : id.match(/^(\dx)/gi)) === null || _a === void 0 ? void 0 : _a[0]) || ''}`; })
            .join(',')
        : undefined;
};
exports.getImagesSrcSet = getImagesSrcSet;
const getDeviceBasedImages = (images = [], mobile) => {
    const device = mobile ? EDeviceType.Mobile : EDeviceType.Desktop;
    const result = images === null || images === void 0 ? void 0 : images.filter(({ id }) => id.includes(device));
    result === null || result === void 0 ? void 0 : result.sort((a, b) => Number(a.id > b.id));
    return result.length ? result : images;
};
exports.getDeviceBasedImages = getDeviceBasedImages;
const useSrcs = (resizedImages = [], noSrc) => {
    var _a, _b;
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const images = (0, exports.getDeviceBasedImages)(resizedImages, mobile);
    const srcSet = noSrc ? '' : (0, exports.getImagesSrcSet)(images);
    return {
        srcSet: srcSet,
        defaultSrc: (_b = (_a = images === null || images === void 0 ? void 0 : images[0]) === null || _a === void 0 ? void 0 : _a.link) === null || _b === void 0 ? void 0 : _b.url,
    };
};
exports.useSrcs = useSrcs;
//# sourceMappingURL=useSrcs.js.map